// esbuild-compatible image loader - replaces Webpack require.context
//
// Each import below resolves to a URL carrying Propshaft's content digest of
// the file ("/assets/bossman_barry-7c1f9a2e.webp"): esbuild writes a
// RAILS_ASSET_URL marker and Propshaft rewrites it when it compiles the bundle
// (esbuild.config.mjs says why — until 3 Nov 2026 these were bare names
// served with a one year cache, so a replaced photograph never reached anyone
// who had already seen the old one). The Ruby side resolves the same logical
// names the same way, so the server-rendered hero and React's copy of it are
// one cache entry.

import logo from '../assets/images/logo.png'
import wordmark from '../assets/images/wordmark.svg'
import wordmarkWhite from '../assets/images/wordmark-white.svg'
import marker from '../assets/images/marker.png'
import icon60pt from '../assets/images/icon_60pt@2x.png'
import loginGoogle from '../assets/images/login_google.svg'
import bossmanBarry from '../assets/images/bossman_barry.webp'
import servicesBricks from '../assets/images/services_bricks.webp'
import footerInstagram from '../assets/images/footer_instagram.svg'
import footerTwitter from '../assets/images/footer_twitter.svg'
import footerFacebook from '../assets/images/footer_facebook.svg'
// The ten curated showcase washes. Nothing imports these by name: the server
// names them in Order::LiveFeed::SHOWCASE_TILES and serves them as feed
// entries with a service and a London postcode attached. They are imported
// here so the bundle's own fall-back gallery (recent-work/feed.js
// fallbackFrames) can resolve them by file name through `image()` below.
// Propshaft precompiles the files themselves from client/gwmc/assets/images,
// which is on config.assets.paths, so an import is no longer what puts them
// on the box.
import gallery01 from '../assets/images/gallery-image-01.webp'
import gallery02 from '../assets/images/gallery-image-02.webp'
import gallery03 from '../assets/images/gallery-image-03.webp'
import gallery04 from '../assets/images/gallery-image-04.webp'
import gallery05 from '../assets/images/gallery-image-05.webp'
import gallery06 from '../assets/images/gallery-image-06.webp'
import gallery07 from '../assets/images/gallery-image-07.webp'
import gallery08 from '../assets/images/gallery-image-08.webp'
import gallery09 from '../assets/images/gallery-image-09.webp'
import gallery10 from '../assets/images/gallery-image-10.webp'

// The before/after pairs (components/before-after): matched 4:3 halves,
// cropped and resized only, 720 x 540.
import baAudiA5BirdDroppingsBefore from '../assets/images/before-after-audi-a5-bird-droppings-before.webp'
import baAudiA5BirdDroppingsAfter from '../assets/images/before-after-audi-a5-bird-droppings-after.webp'
import baEngineBayBefore from '../assets/images/before-after-engine-bay-before.webp'
import baEngineBayAfter from '../assets/images/before-after-engine-bay-after.webp'
import baSoftTopBefore from '../assets/images/before-after-soft-top-before.webp'
import baSoftTopAfter from '../assets/images/before-after-soft-top-after.webp'

const imageMap = {
  './logo.png': logo,
  './wordmark.svg': wordmark,
  './wordmark-white.svg': wordmarkWhite,
  './marker.png': marker,
  './icon_60pt@2x.png': icon60pt,
  './login_google.svg': loginGoogle,
  './bossman_barry.webp': bossmanBarry,
  './services_bricks.webp': servicesBricks,
  './footer_instagram.svg': footerInstagram,
  './footer_twitter.svg': footerTwitter,
  './footer_facebook.svg': footerFacebook,
  './gallery-image-01.webp': gallery01,
  './gallery-image-02.webp': gallery02,
  './gallery-image-03.webp': gallery03,
  './gallery-image-04.webp': gallery04,
  './gallery-image-05.webp': gallery05,
  './gallery-image-06.webp': gallery06,
  './gallery-image-07.webp': gallery07,
  './gallery-image-08.webp': gallery08,
  './gallery-image-09.webp': gallery09,
  './gallery-image-10.webp': gallery10,
  './before-after-audi-a5-bird-droppings-before.webp': baAudiA5BirdDroppingsBefore,
  './before-after-audi-a5-bird-droppings-after.webp': baAudiA5BirdDroppingsAfter,
  './before-after-engine-bay-before.webp': baEngineBayBefore,
  './before-after-engine-bay-after.webp': baEngineBayAfter,
  './before-after-soft-top-before.webp': baSoftTopBefore,
  './before-after-soft-top-after.webp': baSoftTopAfter,
}

export const image = (name) => {
  const img = imageMap[name]
  if (img) return img
  console.warn('Image not found:', name)
  return name
}
